"use strict";
var dragulaExpt = require("dragula");
exports.dragula = dragulaExpt.default || dragulaExpt;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-dragula/components/dragula.class.js
// module id = 430
// module chunks = 6 7 8 12 13 14 15 16 17 18 19